import { InjectionToken, makeStateKey } from '@angular/core';
import { CONFIG } from '@gallaghercp/core-frontend';

export const X_SERVICE_ZONE = new InjectionToken<string>('X_SERVICE_ZONE');
export const SSR_BODY_CLASS = new InjectionToken<string>('SSR_BODY_CLASS');

export interface BootstrapResponse {
    tenantId: string;
    consumerId: string;
    features?: string[];
    appConfig?: Partial<CONFIG>;
}

export interface BootstrapSnapshot extends Partial<CONFIG> {
    serviceProvider?: unknown;
}

export const BOOTSTRAP_STATE_KEY = makeStateKey<BootstrapSnapshot>('core-bootstrap');
